var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3",staticStyle:{"margin":"auto","text-align":"left","white-space":"pre-wrap"}},[_vm._v("\n   "+_vm._s(_vm.$t("privacy_policy", [_vm.hostname]))+"\n ")])}
var staticRenderFns = []

export { render, staticRenderFns }